import BaseMode from './BaseMode';
import Effect from '../Effect/EffectLine';
import Layer from '../Layer/LineModeLayer';
import { DEFAULT_LINE_OPTION } from '../../renderOption';
import { SHAP_TYPE, FUN_TYPE, EFFECT_TAG, LAMP_LAYOUT_SERVICE_MODE, LINE_LAYOUT_SERVICE_MODE, LINE_DIR, EFFECT_LEVEL } from '../../enums/index';
import { calDivideEquallyByRowListInfo, fixedNumber } from '../../utils/common';
import { getRelationWithPointer, transWangePos } from '../../utils/line'; 

/**
 * 初始化data数据
 * @returns 
 */
function getDefaultData () {
  return {
    isSlash: true,
    config: {},
    rendrenOption: {},
    content: null,
    stage: null,
    canvasContent: null,
    curDrawLayerId: 0,
    drawLayer: new Map(),
    isPointerMove: false,
    stageSize: { with: 0, height: 0 },
    curMovePointer: {
      startX: 0,
      startY: 0,
      node: null
    }
  };
}

/**
 * 直角线绘制组件
 */
class LineMode extends BaseMode {
  constructor(props) {
    super(props);

    this.init(props);
  }

  data = getDefaultData();

  init = (props = {}) => {
    this.initProps(props);

    this.data.rendrenOption = this.mergeDrawOption(
      props.rendrenOption,
      DEFAULT_LINE_OPTION
    );

    if (!props.initData) {
      // 首次创建
      this.createDrawLayer(props.stageMapId || 0);
    } else {
      // 根据储存数据回显
      this.revertDrawLayer(props);
    }

    // 注册事件
    this.registerDrawPointer();
  }

  // 恢复回显数据 用于保存过历史数据
  revertDrawLayer(props) {
    const initData = props.initData;
    const activeId = props.stageMapId || 0;
    const historyBgSize = props.historyBgSize;
    // const stageSize = props.stageSize;
    const bgSize = props.bgSize;

    let ratio = 1;

    if (historyBgSize && historyBgSize.width) {
      ratio = Number((bgSize.width / historyBgSize.width).toFixed(2));
    }

    Object.entries(initData).forEach(([ id, drawLayerData = {} ]) => {
      const {
        p: pointerRenderData = {},
        l: lampRenderData = {}
      } = drawLayerData;

      // 创建挂载物图层 false不直接切当前图层【 阻止直接做渲染 】
      this.createDrawLayer(id, false);

      // 切到当前图层
      this.data.curDrawLayerId = id;

      const { m: pointerMode, dl: pointerList } = pointerRenderData;
      const { m: lampMode, l: lampList, c: lampCount } = lampRenderData;

      if (
        pointerMode === LINE_LAYOUT_SERVICE_MODE.LINK &&
        Array.isArray(pointerList)
      ) {
        pointerList.forEach(pointer => {
          const { f: funType, s: shapType, r: serviceRenderData } = pointer;
          // console.log('serviceRenderData', serviceRenderData, ratio);
          
          // 创建节点 但不做渲染
          this.createNewPointer(
            {  offsetX: Math.floor(serviceRenderData.x) * ratio, offsetY: Math.floor(serviceRenderData.y * ratio) },
            false
          );
        })
      }

      // 平均模式 直接按线均值切分灯
      if (
        lampMode === LAMP_LAYOUT_SERVICE_MODE.AVERAGE &&
        lampCount !== 0 &&
        Number.isInteger(lampCount)
      ) {
        this.addLamp(lampCount, false);
      }


      // 平均模式 直接按线均值切分灯
      if (
        lampMode === LAMP_LAYOUT_SERVICE_MODE.SIMGLE_LINE_AVERAGE &&
        Array.isArray(lampList)
      ) {
        this.setLampInfo(lampList)
        this.addLamp(lampCount, false);
      }
    });

    // curDrawLayerId不变化的话不会触发render高亮
    this.data.curDrawLayerId = -1;

    // 激活首个图层 将其余的变暗淡
    this.setCurLineLayerIndexWithAllOpacity(activeId);
    
    // 对所有挂载物进行一次性渲染
    this.renderAllLayer();
  }

  /**
   * 创建新的挂载物
   * @param {*} mapId 
   * @param {*} isSetCurLineLayer 
   */
  createDrawLayer(mapId, isSetCurLineLayer = true) { 
    // Layer {
    //   layer: new window.Konva.Layer({}),
    //   group: new window.Konva.Group({}),
    //   // 双向链表形式 点 -> 线 -> 点
    //   lineNodeQuene: new CircleLineNodeQueue({
    //     render: this.render // flush副作用后渲染函数
    //   }),
    //   // 双向链表形式 灯 -> 灯
    //   lampNodeQueue: new CircleNodeQueue({
    //     render: this.render
    //   }),
    // };
    const drawLayer = new Layer({
      stage: this.data.stage,
      mapId
    });
    
    this.data.drawLayer.set(mapId, drawLayer)
    this.data.stage.add(drawLayer.stateNode);

    // 初始化创建
    if (isSetCurLineLayer && mapId !== 0) {
      this.setCurLineLayerIndex(mapId, false);
    }

    this.addTrackedEventListener(drawLayer.stateNode, 'click', () => {
      this.setCurLineLayerIndex(mapId, true);

      if (this.data && this.data.onActive) this.data.onActive(mapId);
    })

    return drawLayer;
  }

  // 注册图层点击事件 绘制点和线
  registerDrawPointer() {
    this.data.stage.on('mousemove', this.handlerPointerMove);
    this.data.stage.on('mouseup', this.handlerPointerMoveEnd.bind(this));

    // 使用追踪的事件监听器
    this.addTrackedEventListener(this.data.canvasContent, 'mousedown', (e) => {
      if (e && e.which !== 1) {
        this.data.btnInstance && this.data.btnInstance.setIsCanDraw(false);
        return;
      }

      // 无绘制工具栏（如天幕预览）或结束绘制后不允许绘制
      if (!this.data.btnInstance || !this.data.btnInstance.getData().isCanDraw) return;
      // 新增点和连线
      this.createNewPointer(e);
    });
  }

  // 新增点以及连线
  createNewPointer(e, isRender = true) {
    const rendrenOption = this.data.rendrenOption; // 绘图配置
    const drawLayer = this.getCurDrawLayer(); // 当前图层
    const { lampNodeQueue, lineNodeQuene } = drawLayer;
    const { lastCircle, lastLine } = lineNodeQuene.getLastLineAndCircle(); // 上一次点

    const { offsetX, offsetY } = e || {};
    const { x, y } = this.getCurPointerPos(offsetX, offsetY, this.data.isSlash);

    const isExist = lineNodeQuene.isExistPoint(x, y);

    if (isExist) {
      console.log('存在重复点位');
      return;
    }
    
    const insertPointer = this.createCircle({
      x,
      y,
    }, FUN_TYPE.POINTER, rendrenOption.pointer);

    // DrawLayer调用add有推入group的功能 用于z-index展示
    drawLayer.add(insertPointer);

    if (lastCircle) {
      const { x: startX, y: startY } = lastCircle.renderData;
      const startSize = lastLine ? lastLine.renderData.endSize : 0;
      // 创建直角链接的线
      const insertLine = this.createSingleLine({
        startX,
        startY,
        endX: x,
        endY: y,
        startSize,
      }, FUN_TYPE.LINE, rendrenOption.line);

      drawLayer.add(insertLine);

      // 必须先推线 推入双向链表
      lineNodeQuene.push(insertLine);
    }
    // 必须后推点 推入双向链表
    lineNodeQuene.push(insertPointer);

    insertPointer.stateNode.on('mousedown', this.handlerPointerMoveStart.bind(this, insertPointer));

    if (
      (!!lampNodeQueue.count || Array.isArray(lampNodeQueue.circleInfoList)) &&
      lineNodeQuene.getLineAndCircleOnQueue().lineList.length > 0
    ) {
      // 有灯的情况 等添加完灯一起渲染
      this.addLamp(lampNodeQueue.count, isRender);
    } else {
      // 没灯直接渲染
      isRender && this.render();
    }
  }

  // 获取当前点应该落在哪个坐标 (直角坐标xy)
  getCurPointerPos(offsetX, offsetY, isSlash = false) {
    const { lineNodeQuene } = this.getCurDrawLayer();
    const { lastCircle, lastLine } = lineNodeQuene.getLastLineAndCircle();

    const { xWangge, yWangge } = transWangePos(offsetX, offsetY, this.data.wanggePx);

    if (isSlash) {
      return {
        x: xWangge,
        y: yWangge
      };
    };

    // 首次点击
    if (!lastCircle) return { x: xWangge, y: yWangge };

    const { x, y } = lastCircle.stateNode.position();

    // 第三次点击及之后 所有线之后所有点击按直角计算
    if (lastLine) {
      const { direction } = lastLine.renderData;
      
      // 线方向  ROWLR 横向 左 -> 右 ROWRL 横向 右 -> 左 COLTB 纵向 上 -> 下 COLBT 纵向 下 -> 上
      if ([ LINE_DIR.ROWLR, LINE_DIR.ROWRL ].includes(direction)) {
        // 横向 本次走纵向
        return {
          x,
          y: yWangge
        }
      } else {
        // 纵向 本次走横向
        return {
          x: xWangge,
          y
        }
      }
    }

    // 第二次点击以偏移量计算
    const gapX = Math.abs(x - xWangge);
    const gapY = Math.abs(y - yWangge);

    if (gapX > gapY) {
      return {
        x: xWangge,
        y
      }
    } else {
      return {
        x,
        y: yWangge
      }
    }
  }

  // 删除最后一条线
  deleteLastLine = () => {
    const { lineNodeQuene, lampNodeQueue } = this.getCurDrawLayer();
    const { lastCircle, lastLine } = lineNodeQuene.getLastLineAndCircle();

    // 有线必有点 只判断线 
    if (!lastLine) {
      // 只有一个点的时候
      if (lineNodeQuene.isOnlyOneNode()) {
        // 清空所有电和线以及灯的数据
        this.deleteAllLine();
      }

      return;
    };
     
    // flushEffectNode时删除
    lastLine.flags |= EFFECT_TAG.DELETE;
    lastCircle.flags |= EFFECT_TAG.DELETE;

    // 没有灯的情况直接重新渲染
    lineNodeQuene.flushEffectNode(lampNodeQueue.count === 0, lastLine);

    // 有灯的情况 重现加灯且渲染
    if (!!lampNodeQueue.count) this.addLamp(lampNodeQueue.count);
  }

  // 删除当前所有线
  deleteAllLine = () => {
    const drawLayer = this.getCurDrawLayer();
    const { lineNodeQuene, lampNodeQueue } = drawLayer;
    console.log('deleteAllLine deleteAllLine 22');

    // 将点线链表 和 灯链表拼接 一次性处理
    lineNodeQuene.concat(lampNodeQueue);

    let curNode = lineNodeQuene.firstNode;

    while (curNode) {
      // flushEffectNode时删除
      curNode.flags = curNode.flags | EFFECT_TAG.DELETE;

      curNode = curNode.next;
    }

    // 批量执行 并且渲染
    lineNodeQuene.flushEffectNode();

    // concat 后灯节点已由 lineNodeQuene 统一销毁，需重置灯链表引用
    lampNodeQueue.firstNode = null;
    lampNodeQueue.lastNode = null;
    lampNodeQueue.count = 0;
  }

  // 删除所有的线
  deleteAllDrawLayerLine() {
    const allDrawLayer = this.getDrawLayerMap();

    if (!allDrawLayer) return;

    allDrawLayer.forEach((drawLayer) => {
      const { lineNodeQuene, lampNodeQueue } = drawLayer;

      lineNodeQuene.concat(lampNodeQueue);
      
      let curNode = lineNodeQuene.firstNode;

      while (curNode) {
        // flushEffectNode时删除
        curNode.flags = curNode.flags | EFFECT_TAG.DELETE;

        curNode = curNode.next;
      }

      // 批量执行 并且渲染
      lineNodeQuene.flushEffectNode();

      lampNodeQueue.firstNode = null;
      lampNodeQueue.lastNode = null;
      lampNodeQueue.count = 0;
    });
  }

  // // 更新灯数据
  // calLampEffectTagList = () => {
  //   const drawLayer = this.getCurDrawLayer();
  //   const { lampNodeQueue } = drawLayer;
    
  //   const lampXyByCurLayer = this.getLampXyByCurLayer(lampNodeQueue.count); // 获取灯的位置

  //   let curNode = lampNodeQueue.firstNode;
  //   let curIndex = 0;

  //   while (curNode) {
  //     const curData = lampXyByCurLayer[curIndex] || {};

  //     curNode.flags |= EFFECT_TAG.POSITION;
  //     curNode.effects.push(new Effect({
  //       flag: EFFECT_TAG.POSITION,
  //       payload: {
  //         x: curData.x,
  //         y: curData.y
  //       }
  //     }));

  //     curIndex++;
  //     curNode = curNode.next;
  //   }
  // }

  getLampXyByCurLayerInArray = (lampInfo) => {
    const { lineNodeQuene } = this.getCurDrawLayer();
    const { size: lineSize, direction, nodeList } = lineNodeQuene.getMainLine();

    let lampData = null;
    let lastData = null;

    nodeList.forEach((curNode, curNodeIndex) => {
      const lampCount = Number(lampInfo[curNodeIndex]) || 0;
      
      const curLineSize = curNode.renderData.size;        
      const singleLampSize = lampCount === 1 ? curLineSize / 2 : curLineSize / (lampCount - 1);

      for (let i = 0; i < lampCount; i++) {
        // 一个灯位直接布在中间 线左右端点本身各占一个灯位
        const index = lampCount === 1 ? i + 1 : i;
        const { startX, startY, endX, endY, startSize, size, direction } = curNode.renderData || {};
        let curData = null;
        const moveSize = singleLampSize  * index;

        const props_angle = (moveSize / size);
        const minsX = (endX - startX) * props_angle;
        const minxY = (endY - startY) * props_angle;
    
        switch (direction) {
          // 横向 左 -> 右 
          case LINE_DIR.ROWLR:
            curData = {
              x: startX + moveSize,
              y: startY
            };
            break;
          // 横向 右 -> 左
          case LINE_DIR.ROWRL:
            curData = {
              x: startX - moveSize,
              y: startY
            };
            break;
          // 纵向 上 -> 下
          case LINE_DIR.COLTB:
            curData = {
              x: startX,
              y: startY + moveSize,
            };
            break;
          // 纵向 下 -> 上
          case LINE_DIR.COLBT:
            curData = {
              x: startX,
              y: startY - moveSize
            };
            break;
          case LINE_DIR.ANGLE_ROW_LR:
          case LINE_DIR.ANGLE_ROW_RL:
          case LINE_DIR.ANGLE_COL_TB:
          case LINE_DIR.ANGLE_COL_BT:
            curData = {
              x: startX + minsX,
              y: startY + minxY
            };
            break;
        }
  
        if (!lampData) {
          lampData = curData;
        } else if (!!lastData) {
          lastData.next = curData;
        }
  
        lastData = curData;
      }
    })

   return lampData;
  }

  // 获取每个灯的点位
  getLampXyByCurLayer = (iptCount) => {
    let count = iptCount;
    const { lineNodeQuene, lampNodeQueue } = this.getCurDrawLayer();
    let lampCount = Number(count);
// console.log('getLampXyByCurLayer', lampNodeQueue.circleInfoList);

    // 1个灯全线均分 多个灯按每条线均分
    if (
      Array.isArray(lampNodeQueue.circleInfoList) && 
      lampNodeQueue.circleInfoList.length > 1
    ) {
      return this.getLampXyByCurLayerInArray(lampNodeQueue.circleInfoList)
    }

    if (
      Array.isArray(lampNodeQueue.circleInfoList) && 
      lampNodeQueue.circleInfoList.length === 1
    ) {
      lampCount = count = Number(lampNodeQueue.circleInfoList[0]);
    }


    const { lineList } = lineNodeQuene.getLineAndCircleOnQueue();

    if (lineList.length === 0) return null;
   
    const lineSize = lineNodeQuene.getLineSize(); // 总线长
    
    // 每段距离 由于线左右端点本身各占一个灯位
    const singleLampSize = count === 1 ? lineSize / 2 : lineSize / (lampCount - 1);
    // console.log('getLampXyByCurLayer',lineSize, singleLampSize, lampCount + 1);
    let lampData = null;
    let lastData = null;
    
    for (let i = 0; i < lampCount; i++) {
      // 一个灯位直接布在中间 线左右端点本身各占一个灯位
      const index = count === 1 ? i + 1 : i;
      const curStepSize = singleLampSize * index;

      // 命中的线
      const hitLine = lineList.find(
        item => curStepSize >= item.renderData.startSize &&
        curStepSize <= item.renderData.endSize
      ) || lineNodeQuene.getLastLineAndCircle().lastLine;
      
      const { startX, startY, startSize, direction, size, endX, endY } = hitLine.renderData || {};
      const moveSize = fixedNumber(curStepSize - startSize);

      let curData = null;

      const props_angle = (moveSize / size);
      const minsX = (endX - startX) * props_angle;
      const minxY = (endY - startY) * props_angle;

      // console.log('direction', direction, (endY - endX) / );
      switch (direction) {
        // 横向 左 -> 右 
        case LINE_DIR.ROWLR:
          curData = {
            x: startX + moveSize,
            y: startY
          };
          break;
        // 横向 右 -> 左
        case LINE_DIR.ROWRL:
          curData = {
            x: startX - moveSize,
            y: startY
          };
          break;
        // 纵向 上 -> 下
        case LINE_DIR.COLTB:
          curData = {
            x: startX,
            y: startY + moveSize,
          };
          break;
        // 纵向 下 -> 上
        case LINE_DIR.COLBT:
          curData = {
            x: startX,
            y: startY - moveSize
          };
          break;
        case LINE_DIR.ANGLE_ROW_LR:
        case LINE_DIR.ANGLE_ROW_RL:
        case LINE_DIR.ANGLE_COL_TB:
        case LINE_DIR.ANGLE_COL_BT:
          curData = {
            x: startX + minsX,
            y: startY + minxY
          };
          break;
      }

      if (i === 0) {
        lampData = curData;
      } else if (!!lastData) {
        lastData.next = curData;
      }

      lastData = curData;
    }

    return lampData;
  }

  // 处理点击节点后拖动前置工作
  handlerPointerMoveStart (curPointer, e) {
    // 不允许编辑
    if (this.data.btnInstance && !this.data.btnInstance.getData().isCanEdit) return;

    const position = curPointer.renderData;

    this.data.curMovePointer.startX = position.x;
    this.data.curMovePointer.offsetY = position.y;
    this.data.curMovePointer.node = curPointer;

    // 获取前后节点
    const { prePointer, nextPointer } = this.getEffectNodeList(curPointer, this.data.isSlash);

    // 在node上缓存节点当前位置信息
    if (prePointer) prePointer.renderData.startMovePosition = prePointer.renderData;
    if (nextPointer) nextPointer.renderData.startMovePosition = nextPointer.renderData;

    // 可以进行拖动了
    this.data.isPointerMove = true;
  }

  // 拖动过程处理
  handlerPointerMove = (e) => {
    // 不允许编辑
    if (this.data.btnInstance && !this.data.btnInstance.getData().isCanEdit) return;
    // 鼠标抬起状态不能拖动
    if (!this.data.isPointerMove) return;

    const { offsetX, offsetY } = e.evt || {};
    const drawLayer = this.getCurDrawLayer();
    const { lampNodeQueue, lineNodeQuene } = drawLayer;
  
    // 获取所有造成影响的node 包括当前点前后2个点和线
    const effectNodeList = this.getEffectNodeList(this.data.curMovePointer.node);
    // 对有副作用的节点打上effectTag
    const firstEffectTagNode = this.calEffectTagList(offsetX, offsetY, effectNodeList);
    // 批量处理有副作用的节点 更新renderData 将副作用映射成node位置
    lineNodeQuene.flushEffectNode(false, firstEffectTagNode);
    // 更新灯位置 对node打上副作用 此处add不会新增 会利用老节点进行move操作
    this.addLamp(lampNodeQueue.count);
  }

  // 拖动结束 stage 和 点 mouseup 都会触发
  handlerPointerMoveEnd = (e) => {
    // 不允许编辑
    if (this.data.btnInstance && !this.data.btnInstance.getData().isCanEdit) return;
    // 鼠标抬起状态不能拖动
    if (!this.data.isPointerMove) return;

    const { offsetX, offsetY } = e.evt || {};
    const drawLayer = this.getCurDrawLayer();
    const { lampNodeQueue, lineNodeQuene } = drawLayer;
  
    // 获取所有造成影响的node 包括当前点前后2个点和线
    const effectNodeList = this.getEffectNodeList(this.data.curMovePointer.node);

    const { xWangge, yWangge } = transWangePos(offsetX, offsetY, this.data.wanggePx);

    const isExist = lineNodeQuene.isExistPoint(xWangge, yWangge);

    if (isExist) {
      console.log('存在重复点位');
      // return;
    }

    // 对有副作用的节点打上effectTag
    const firstEffectTagNode = this.calEffectTagList(xWangge, yWangge, effectNodeList);
    // 批量处理有副作用的节点 更新renderData 将副作用映射成node位置
    lineNodeQuene.flushEffectNode(false, firstEffectTagNode);
    // 更新灯位置 对node打上副作用 此处add不会新增 会利用老节点进行move操作
    this.addLamp(lampNodeQueue.count);
    // 不可以进行拖动
    this.data.isPointerMove = false;
  }

  // 获取所有可能造成影响的node 包括当前点的 前后2个点和线
  getEffectNodeList(current, isSlash = false) {
    const preLine = current.pre;
    const prePointer = (preLine || {}).pre;
    const prePreLine = (prePointer || {}).pre;
    const prePrePointer = (prePreLine || {}).pre;

    const nextLine = current.next;
    const nextPointer = (nextLine || {}).next
    const nextNextLine = (nextPointer || {}).next;
    const nextNextPointer = (nextNextLine || {}).next;

    return {
      current,
      preLine,
      nextLine,
      prePointer,
      nextPointer,
      prePreLine,
      prePrePointer,
      nextNextLine,
      nextNextPointer
    }
  }

  // 计算副作用
  calEffectTagList(currentX, currentY, effectNodeList) {
    const drawLayer = this.getCurDrawLayer();
    const {
      current,
      preLine,
      prePointer,
      prePreLine,
      prePrePointer,
      nextLine,
      nextPointer,
      nextNextLine,
      nextNextPointer
    } = effectNodeList;

    // 计算前2点2线的副作用
    this.createEffectOnNode({
      siblingPointer: prePointer,
      siblingLine: preLine,
      siblingSiblingPointer: prePrePointer,
      siblingSiblingLine: prePreLine,
      currentX,
      currentY,
      type: 'pre'
    })

    // 计算后2点2线的副作用
    this.createEffectOnNode({
      siblingPointer: nextPointer,
      siblingLine: nextLine,
      siblingSiblingPointer: nextNextPointer,
      siblingSiblingLine: nextNextLine,
      currentX,
      currentY,
      type: 'next'
    });
  
    const allMoveLine = drawLayer.lineNodeQuene.findAllMoveEffectLine(); // 获取移动过的所有线
    const lastMoveLine = allMoveLine[allMoveLine.length - 1] || {};
    const firstNoEffectLine = (lastMoveLine.next || {}).next; // 后续首个没有副作用的线
    // console.log('firstNoEffectLine', allMoveLine, firstNoEffectLine);

    // 记录第一根没有副作用的线 因为线需要整体更新线长和开始线长结束线长 需要推入updateRenderData的副作用
    if (firstNoEffectLine) {
      let curNode = firstNoEffectLine;

      while (curNode) {
        curNode.flags |= EFFECT_TAG.UPDATE_RENDER_DATA;
        curNode.effects.push({
          flag: EFFECT_TAG.UPDATE_RENDER_DATA,
          payload: {
            data: {}
          }
        })

        curNode = (curNode.next || {}).next;
      }
    }

    current.flags = current.flags | EFFECT_TAG.POSITION;
    current.effects.push(new Effect({
      flag: EFFECT_TAG.POSITION,
      payload: {
        x: currentX,
        y: currentY
      }
    }))

    // 由于当前点可能在首个或第二个获取不到prepre 此处返回首个存在有副作用的点
    return prePreLine || prePointer || preLine || current || nextLine;
  }

  // 针对点前或后的点和线打上effectTag副作用 用于更新renderData以及更新图状态
  createEffectOnNode({ siblingLine, siblingPointer, siblingSiblingLine, siblingSiblingPointer, currentX, currentY, type }) {
    const { startX } = this.data.curMovePointer; // 当前移动的点x
    const isNext = type === 'next';

    if (siblingPointer) {      
      console.log('hchiu', { siblingLine, siblingPointer, siblingSiblingLine, siblingSiblingPointer, currentX, currentY, type });
      
      const { startMovePosition } = siblingPointer.renderData; // 边上的点 【type:next 是链表右侧 pre 是链表左侧】

      const relation = getRelationWithPointer(startX, startMovePosition.x);

      // LINE_DIR.ROW 横向
      const x = relation === LINE_DIR.ROW ? startMovePosition.x : currentX;
      const y = relation === LINE_DIR.ROW ? currentY : startMovePosition.y

      let siblingLinePayload = {};

      if (this.data.isSlash) {
        siblingLinePayload = {
          startX: isNext ? currentX : siblingLine.renderData.startX,
          startY: isNext ? currentY : siblingLine.renderData.startY,
          endX: isNext ? siblingLine.renderData.endX : currentX,
          endY: isNext ? siblingLine.renderData.endY : currentY
        }
      } else {
        // 推入点定位的副作用
        siblingPointer.flags = siblingPointer.flags | EFFECT_TAG.POSITION;
        siblingPointer.effects.push(new Effect({
          flag: EFFECT_TAG.POSITION,
          payload: {
            x,
            y
          }
        }));

        siblingLinePayload = {
          startX: isNext ? currentX : x,
          startY: isNext ? currentY : y,
          endX: isNext ? x : currentX,
          endY: isNext ? y : currentY
        }
      }

      // 推入线定位的副作用
      siblingLine.flags = siblingLine.flags | EFFECT_TAG.POINTS;
      siblingLine.effects.push(new Effect({
        flag: EFFECT_TAG.POINTS,
        // 链表往右侧走的情况当前点为起点 siblingPointer为终点 反之倒转
        payload: siblingLinePayload
      }));

      // 隔壁再隔壁的线变化
      if (siblingSiblingLine && !this.data.isSlash) {
        const { x: siblingSiblingX, y: siblingSiblingY } = siblingSiblingPointer.stateNode.position();

        siblingSiblingLine.flags = siblingSiblingLine.flags | EFFECT_TAG.POINTS;
        siblingSiblingLine.effects.push(new Effect({
          flag: EFFECT_TAG.POINTS,
          // 链表往右侧走的情况兄弟点为起点 兄弟兄弟节点为终点 反之倒转
          payload: {
            startX: isNext ? x : siblingSiblingX,
            startY: isNext ? y : siblingSiblingY, 
            endX: isNext ? siblingSiblingX : x,
            endY: isNext ? siblingSiblingY : y
          }
        }));
      }
    }
  }

  // 通过双向链表更新所有shapes的数据
  // updateShapesListDataByQueue() {
  //   const { lineNodeQuene, shapes } = this.getCurDrawLayer();

  //   const firstNode = lineNodeQuene.firstNode;

  //   if (!firstNode) return;

  //   const newLineList = [];
  //   const newPointerList = [];

  //   let curNode = firstNode;

  //   while (curNode) { 
  //     if (curNode.shapeType === SHAP_TYPE.CIRCLE) {
  //       newPointerList.push({
  //         node: curNode,
  //         ...curNode.position()
  //       })
  //     }

  //     if (curNode.shapeType === SHAP_TYPE.LINE) {
  //       const prePointer = curNode.pre;
  //       const nextPointer = curNode.next;
  //       const prePos = prePointer.stateNode.position();
  //       const nextPos = nextPointer.stateNode.position();
  //       const size = getSingleLineSize(prePos.x, prePos.y, nextPos.x, nextPos.y);
  //       const startSize = !!newLineList.length ? newLineList[newLineList.length - 1].endSize : 0;
  
  //       newLineList.push({
  //         node: curNode,
  //         startX: prePos.x,
  //         startY: prePos.y,
  //         endX: nextPos.x,
  //         endY: nextPos.y,
  //         size, // 当前线长度
  //         startSize,
  //         endSize: startSize + size, // 当前灯带总长
  //         direction: getLineDirection(prePos.x, prePos.y, nextPos.x, nextPos.y)
  //       })
  //     }

  //     curNode = curNode.next;
  //   }
    
  //   shapes.line.list = newLineList;
  //   shapes.pointer.list = newPointerList;
  // }

  // 获取所有灯位数据
  getAllLampPosition(mapId) {
    const drawLayer = this.getCurDrawLayer(mapId);
    const { lampNodeQueue } = drawLayer;

    const lampPositionList = [];
    
    let curNode = lampNodeQueue.firstNode;

    while (curNode) {
      lampPositionList.push({
        x: curNode.renderData.x,
        y: curNode.renderData.y,
      });

      curNode = curNode.next;
    }

    return lampPositionList;
  }

  // 创建随机 { mapIds.length } 条线 y为中间值
  createRandomLine(mapIds = []) {
    const lastId = this.data.curDrawLayerId;

    mapIds.forEach(item => {
      const { mapId } = item;

      this.setCurLineLayerIndex(mapId);

      const y = this.data.stageSize.height / 2;
      const data = [{ x: 40, y }, { x: this.data.stageSize.width - 40, y}];

      for (let i = 0; i < 2; i++) {
        this.createNewPointer({
          offsetX: data[i].x,
          offsetY: data[i].y,
        }, i === 2)
      }
    });

    this.setCurLineLayerIndex(lastId);
  }

  // 均分所有线圈 会按目前纵横比 自动计算横向还是纵向均分剩余空间
  // 目前没做碰撞检测逻辑 只能按顺位一行或一列一个设备排列
  divideEqually() {
    const rowListInfo = [];

    this.data.drawLayer.forEach((drawLayer, id) => {
      const { lineNodeQuene } = drawLayer
      const rowColSize = {
        id,
        row: 0,
        col: 0,
        maxTop: Infinity,
        maxBottom: 0,
        maxLeft: Infinity,
        maxRight: 0
      }

      let curNode = lineNodeQuene.firstNode;

      while (curNode) {
        const { renderData: renderData } = curNode;

        if (curNode.shapeType === SHAP_TYPE.CIRCLE) {
          const { x, y } = renderData;

          if (y < rowColSize.maxTop) rowColSize.maxTop = y;
          if (y > rowColSize.maxBottom) rowColSize.maxBottom = y;
          if (x < rowColSize.maxLeft) rowColSize.maxLeft = x;
          if (x > rowColSize.maxRight) rowColSize.maxRight = x;
        } else {
          // 线方向 ROWLR ROWRL 横向
          if ([LINE_DIR.ROWLR, LINE_DIR.ROWRL].includes(renderData.direction)) {
            rowColSize.row += renderData.size;
          } else {
            rowColSize.col += renderData.size;
          }
        }

        curNode = curNode.next;
      }

      if (lineNodeQuene.firstNode) {
        rowListInfo.push(rowColSize)      
      }
    })

    // 计算平分属性
    const divideRowListInfo = calDivideEquallyByRowListInfo(
      rowListInfo,
      this.data.bgSize.width,
      this.data.bgSize.height
    );

    console.log('divideRowListInfo', divideRowListInfo);
    

    this.data.drawLayer.forEach((drawLayer, id) => {
      const type = divideRowListInfo.type;
      const info = divideRowListInfo.data.find(item => item.id === id);
      const { lineNodeQuene, lampNodeQueue } = drawLayer;
      let curNode = lineNodeQuene.firstNode;

       // 将灯链表拼接至点线链表后面一次性更新
      lineNodeQuene.concat(lampNodeQueue);

      while (curNode) {
        // 点调用move
        if (curNode.shapeType === SHAP_TYPE.CIRCLE) {
          // 按纵向还是横向分割移动
          const payload = type === 'row' ? { x: fixedNumber(info.moveX), y: 0 } : { x: 0, y: fixedNumber(info.moveY) };

          curNode.flags |= EFFECT_TAG.MOVE;
          curNode.effects.push({
            flag: EFFECT_TAG.MOVE,
            payload
          })
        } else {
          // 线不能使用move 不然后续points定位会出现偏移
          const { renderData: renderData } = curNode;
          const payload = type === 'row' ? { 
            startX:  fixedNumber(renderData.startX + info.moveX),
            startY: fixedNumber(renderData.startY),
            endX: fixedNumber(renderData.endX + info.moveX),
            endY: fixedNumber(renderData.endY)
          } : { 
            startX:  fixedNumber(renderData.startX),
            startY: fixedNumber(renderData.startY + info.moveY),
            endX: fixedNumber(renderData.endX),
            endY: fixedNumber(renderData.endY + info.moveY),
          };

          curNode.flags |= EFFECT_TAG.POINTS;
          curNode.effects.push({
            flag: EFFECT_TAG.POINTS,
            payload
          })
        }
        
        curNode = curNode.next;
      }

      curNode = lampNodeQueue.firstNode;

      lineNodeQuene.flushEffectNode(false);

      // 将灯链表和点线链表断开连接
      lineNodeQuene.break();
    })

    // 渲染所有图层
    this.renderAllLayer();
  }

  // 获取保存的数据 用于上传服务端
  // 此处由于以字符串形式储存 所以为节约落库表的字段名以精简为主
  // 此处只储存点的数据 并不记录线和灯的坐标 服务下发后 根据mode恢复
  getSaveData = () => {
    const drawLayerData = {};

    this.data.drawLayer.forEach((drawLayer, id) => {
      console.log('drawLayer', drawLayer);

      const circleInfoList = drawLayer.lampNodeQueue.circleInfoList;
      const mode = Array.isArray(circleInfoList) && circleInfoList.length > 1 ? LAMP_LAYOUT_SERVICE_MODE.SIMGLE_LINE_AVERAGE : LAMP_LAYOUT_SERVICE_MODE.AVERAGE;
      const data = {
        // pointerrDataQuene
        p: {
          // dataList
          dl: [],
          // 
          m: LINE_LAYOUT_SERVICE_MODE.LINK
        },
        // lampRenderDataQueue
        l: {
          // mode
          m: mode,
          // 数量
          c: drawLayer.lampNodeQueue.count,
          // 没跟灯带上的位置
          l: circleInfoList
        }
      }

      // 储存点线的数据 
      let curNode = drawLayer.lineNodeQuene.firstNode;

      while (curNode) {
        // LINE_LAYOUT_SERVICE_MODE.LINK模式 只储存点信息 线信息加载的时候恢复 
        if (curNode.shapeType === SHAP_TYPE.CIRCLE) {
          const nodeInfo = {
            // shapType
            s: curNode.shapeType,
            // funType
            f: curNode.funType,
            // renderData
            r: curNode.getSaveRenderData() || {}
          }
          
          data.p.dl.push(nodeInfo);
        }

        curNode = curNode.next;
      }
  
      // 由于走过一次JSON.stringify lastNode 和 firstNode 内存地址脱钩 没必要存
      delete data.p.l;
      drawLayerData[id] = data;
    })

    return drawLayerData;
  }
}

export default LineMode;